import React from 'react';
import auth from 'src/services/auth';
import styles from './HelpSubMenu.module.less';

const HelpSubMenu: React.FC = () => {
  const isExpretio = auth.getSkin() === 'Expretio XCS' || auth.getSkin() === 'Expretio Rivalis';

  return (
    <ul className={styles.menu}>
      <li>
        {isExpretio ? (
          <a href="mailto:support@expretio.com" className={styles.link}>
            support@expretio.com
          </a>
        ) : (
          <a href="https://ql2.zendesk.com/hc/en-us/requests" target="_blank" rel="noopener">
            Technical Support
          </a>
        )}
      </li>
      <li>
        <a href="https://www.ql2.com/knowledge-base/" target="_blank">
          Knowledge Base
        </a>
      </li>
    </ul>
  );
};

export default HelpSubMenu;
